import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

const SessionExpiredDialog = ({ open, onLogin }) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="session-expired-dialog"
      aria-describedby="session-expired-description"
      disableEscapeKeyDown
    >
      <DialogTitle id="session-expired-dialog">
        Session Expired
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-expired-description">
          Your session has expired due to inactivity. Please log in again to continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{
        paddingBottom: 4,
        paddingRight: 4
      }}>
        <Button onClick={onLogin} variant="contained" color="primary" autoFocus>
          Log In
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionExpiredDialog;